
// set logo and nav height the same on desktop
var windowWidth = $(window).outerWidth();
if (windowWidth > 768 && $('.inline-nav').length === 0) {
  var logoHeight = $('.header__heading-logo').outerHeight();
  $('.main-nav-container').outerHeight(logoHeight);
  $('#main-nav').outerHeight(logoHeight);
}
if ($('.main-nav-center').length > 0) {
  var pageWidth = $('.page-width').width();
  
  var logoWidth = $('.logo-container').width();
  var padding = $('#main-nav').css('padding-left');
  var totalNavItem = 0;
  $('.main-link').each(function(i) {
    var linkWidth = $(this).outerWidth();
    totalNavItem += linkWidth;
  });
var widthDiff = (pageWidth/2) - totalNavItem;
$('#main-nav').css('padding-left',widthDiff);
}
if ($('.inline-nav').length > 0) {
  var pageWidth = $('.page-width').width();
  var logoWidth = $('.logo-container').width();
  var pageWidthDivided = pageWidth / 2;
  var logoWidthDivded = logoWidth / 2;
  var navWidth = pageWidthDivided - logoWidthDivded;
  $('#main-nav').css('width',navWidth+'px');
}
$('.main-link.extra-links').hover(function() {
  $('.main-link.extra-links.active').removeClass('active');
  $('.sub-container.visible').removeClass('visible')
  $(this).addClass('active');
    var subContainer = $(this).find('.sub-container');
  if ($('#shopify-section-header').width() > 1200) {
        subContainer.css('width',1200);
  }
  else {
       subContainer.css('width',$('#shopify-section-header').width() - 20); 
  }
    subContainer.css('top',$('#shopify-section-header').outerHeight());
  
  // determine window width
  var windowWidth = $(window).width();
  
  var gapWidth = (windowWidth - subContainer.outerWidth()) / 2 ;
    var position = subContainer.offset();
  var left = gapWidth - 30;
    var offset = left + 'px';
//   subContainer.css('left',offset);
    var sublinkLength = subContainer.find('.sub-links').length;
    if (sublinkLength > 4) {
      sublinkLength = 4;
    }
    var sublinkWidth = (100 / sublinkLength) - 2;
    sublinkWidth = sublinkWidth + '%';
    subContainer.find('.sub-links').css('width',sublinkWidth);
    subContainer.addClass('visible');
},function(){
    var intervalId = setInterval(function() {
    if($('.sub-container.visible:hover').length != 0 || $('.main-link.extra-links.active:hover').length != 0) {
   // let it be visible
    }
    else {
    $('.sub-container.visible').removeClass('visible');
    clearInterval(intervalId);
  }
  }, 250);
});
$('.image-text-flex').each(function() {
  var windowW = $(window).width();
  
  if (windowW > 768) {
  var height = $(this).outerHeight();
  // $(this).find('.container-flex.img').css('min-height',height);
}
else {
  // do nothing, it's mobile
}
});
var windowW = $(window).width();

if (windowW > 768) {
$('.product-card-container').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  draggable: true,
  freeScroll: true,
  pageDots: false,
  wrapAround: true,
  lazyload:true,
  imagesLoaded: true,
  prevNextButtons: false
});

$('.testimonial-flex').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  draggable: true,
  freeScroll: true,
  pageDots: true,
  wrapAround: true,
  imagesLoaded: true,
  groupCells:3,
  prevNextButtons: false
});
}
else {
  var length = $('.product-card-container').find('.product-cart-item').length;
  $('.product-card-container').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    draggable: true,
    freeScroll: true,
    pageDots: true,
    groupCells: Math.ceil(length / 3),
    wrapAround: true,
    prevNextButtons: false
  });

  $('.testimonial-flex').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    draggable: true,
    freeScroll: true,
    pageDots: true,
    wrapAround: true,
    groupCells:1,
    prevNextButtons: false
  });

  $('.icon-wrapper.product').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    draggable: true,
    freeScroll: true,
    pageDots: true,
    wrapAround: true,
    groupCells:1,
    prevNextButtons: false
  });
}
$('.gallery-slider').each(function() {
    if (windowW > 768) {
      var cells = $(this).attr('group-cells');
      var length = $(this).find('.gallery-link-item').length;
      if (length > cells) {
        $(this).flickity({
          // options
          cellAlign: 'left',
          contain: false,
          draggable: true,
          freeScroll: true,
          pageDots: true,
          wrapAround: true,
          groupCells:cells,
          prevNextButtons: false
        });
      } else {
          $(this).addClass('flexy');
      }
    } else {
      $(this).flickity({
      // options
      cellAlign: 'left',
      contain: false,
      draggable: true,
      freeScroll: true,
      pageDots: true,
      wrapAround: true,
      prevNextButtons: false
    });
    }
});
$('.gallery-slider').each(function () {
  var left_margin = $(this).find('.flickity-viewport').find('.flickity-slider').find('.gallery-link-item').eq(1).css('margin-left');
  $(this).find('.flickity-viewport').css('margin-left',left_margin);
  if (windowW > 768) {
    $(this).find('.flickity-viewport').css('height','40vh');
  } else {
    $(this).find('.flickity-viewport').css('height','55vh');
  }
//  $(this).find('.flickity-viewport').find('.flickity-slider').find('.gallery-link-item').eq(0).css('margin-left',left_margin)
});
$('div').each(function () {
  var id = $(this).attr('id');
  if (typeof id != "undefined") {
  if (id.indexOf('shopify-section-template') > -1) {
    if($(this).find('div').eq(0).css('display') == 'none') {
      $(this).css('margin-top',0);
      $(this).css('margin-bottom',0)
    }
  }
}
});
$('.footer-flex-item').click(function (e) {
  var target = $(e.target.className);
  var origTarget = $(e.target);
  var classTarget = origTarget[0]['className'];
  if(classTarget === 'footer-item' || classTarget === 'footer-link') {

  }
  else {
  if (!$(this).hasClass('active')) {
  $(this).find('.footer-item').slideDown();
  $(this).addClass('active');
  $(this).find('.bold-item').addClass('active');
}
else {
  $(this).find('.footer-item').slideUp();
  $(this).removeClass('active');
  $(this).find('.bold-item').removeClass('active');
}
}
});
var menuHeight = $('#main-header').outerHeight();
$('.mobile-nav-container').css('top',menuHeight);
$('.mobile-nav-container .sub-links').each(function() {

});
//mobile navigation logic
$('#mobile-nav').click(function(e) {
  e.preventDefault();
  if ($('.hamburger-svg').css('display') === 'inline') {
    $('.hamburger-svg').hide();
    $('.menu-svg').show();
    $('.mobile-nav-container').slideDown();
    $('body').css({ 'overflow': 'hidden' });
  }
  else {
    $('.hamburger-svg').show();
    $('.menu-svg').hide();
    $('.mobile-nav-container').slideUp();
    $('body').css({ 'overflow': 'auto' });
  }
});
$('.mobile-nav-container .main-link').click(function(e) {
    e.preventDefault();
    var index = $(this).index('.main-link');
  
    var active = $(this).attr('data-active');
    if (typeof active === 'undefined') {
      $(this).attr('data-active','active');
      $(this).find('.icon-chevron-right').hide();
      $(this).find('.icon-chevron-left').show();
      $('.mobile-nav-container .main-link').each(function(i){
        if (index != i) {
      
          $(this).hide();
        }
      });
    }
    else {
    $(this).removeAttr('data-active');
    $(this).find('.icon-chevron-right').show();
    $(this).find('.icon-chevron-left').hide();
    $('.mobile-nav-container .main-link').show();
  }
    var subLinkExist = 0;
     var thisCLass = $(this).attr('class').replace('main-link','');
 
   $('.mobile-nav-container .sub-links').each(function(i) {
     var subClass = $(this).attr('class');
     if (subClass.indexOf(thisCLass) > -1) {
       if (active === 'active') {
         $(this).hide();
       }
       else {
       $(this).slideDown();
     }
       subLinkExist = 1;
     }
   });
   if (subLinkExist === 0) {
     var href = $(this).attr('href');
     window.location.href = href;
   }
   else {
     // keep preventing default, we have links
   }
 });
// $('.mobile-nav-container .sub-link-title').click(function(e) {
//   e.preventDefault();
//   var titleType = $(this).attr('data-title');
//   if ($(this).hasClass('active')) {
//     $(this).removeClass('active');
//     $('.sub-link-link').each(function() {
//       var subtitleType = $(this).attr('data-title');
      
//       if (titleType === subtitleType) {
//         $(this).slideUp();
//       }
//     });

//   }
//   else {
//   $(this).addClass('active');
 
//   $('.sub-link-link').each(function() {
//     var subtitleType = $(this).attr('data-title');
 
//     if (titleType === subtitleType) {
//       $(this).slideDown();
//     }
//   });
// }
// });


  $(document).ready(function(){
    $(document).on('click','.filterLabel',function(){
      $(this).toggleClass('open-filter')
      $(this).next().slideToggle();
      
    })
  });

$(".change-color1").click(function(){
  $(".preve-pagination").addClass("change-color");
});

$(".pagination__item ").click(function(){
  $(".preve-pagination").remove("change-color");
});

$(".change-color5").click(function(){
  $(".next-pagination").addClass("change-colors");
});

$(".change-color5").click(function(){
  $(".next-pagination").remove("change-colors");
});


// FILTER AJAX

   $(document).on('click','.filter-item input',function(e){
    if (windowW > 768) {
      e.preventDefault();
      $('.filter-form').submit();
    }
});

function createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
}

  $(document).on('submit','.filter-form',function(e){
  e.preventDefault();
     $('.collections-grid-custom').addClass('loading');
     $('.filter-details-loading').addClass('active');
  const sortFilterForms = document.querySelectorAll('.filter-details-container form');
  var data_collection_url = $("#ProductGridContainer").attr('data-collection-url');
 var selectedCountry = $('.facet-filters__sort').children("option:selected").val();
    
//     console.log(selectedCountry);
  const forms = [];
   sortFilterForms.forEach((form) => {
          forms.push(createSearchParams(form));
      });
      var url = forms.join('&');
  
    let final_url = data_collection_url +'?'+ url +'&sort_by='+ selectedCountry;
       $.ajax({
          type: 'GET', 
          url: final_url,
          dataType: 'html', 
          success: function (filter_html){
           $('#ProductGridContainer').html($(filter_html).find('#ProductGridContainer').html());   
            $('.filter-form').html($(filter_html).find('.filter-form').html());   
            window.history.pushState(location.href, "", final_url);
            $('.facet-filters__sort').val(selectedCountry);
            $('.collections-grid-custom').removeClass('loading');
            $('.filter-details-loading').removeClass('active');
            if (windowW < 768) {
              $('.wrong-icon-filter').click();
            }
            const api = new Yotpo.API(window.yotpo);
            api.refreshWidgets();
            window.yotpo.initWidgets();

          },
          error: function(){   
            $('.collections-grid-custom').removeClass('loading');
            $('.filter-details-loading').removeClass('active');
            console.log("error");
          }
        });      
});




//Remove Filter
$(document).ready(function() {
  $(document).on('click','.active-filters__remove-filter',function(e){
    e.preventDefault();    
    let new_url = $(this).attr('href');
//     console.log(new_url);
     $.ajax({
          type: 'GET', 
          url: new_url,
          dataType: 'html', 
          success: function (filter_html){ 
           $('#ProductGridContainer').html($(filter_html).find('#ProductGridContainer').html());   
            $('.filter-form').html($(filter_html).find('.filter-form').html());   
            window.history.pushState(location.href, "", new_url);

            const api = new Yotpo.API(window.yotpo);
            api.refreshWidgets();
            window.yotpo.initWidgets();

          },
          error: function(){   
            console.log("error");
          }
        });    
  });    
});


// $(document).on('click','.switch',function(e){
//     let inputVal = $(this).find(':checked');    
//     setTimeout(function(){
//       if(inputVal.length == 1){
//         $('.shipping-in-1-or-2-days input').trigger('click');
//       }else{
//         $('.shipping-in-1-or-2-days .active-filter input:checked').trigger('click');
//       }       
//     },200);
//   }); 






// Check Box 
$(document).ready(function() {
  let inputVal = $('.switch').find(':checked');    
  setTimeout(function(){
    if(inputVal.length == 1){
      $('.shipping-in-1-or-2-days input').trigger('click');
    }else{
      $('.shipping-in-1-or-2-days .active-filter input:checked').trigger('click');
    }       
  },200);
  $(document).on('click','.switch',function(e){
    let inputVal = $(this).find(':checked');    
    setTimeout(function(){
      if(inputVal.length == 1){
        $('.shipping-in-1-or-2-days input').trigger('click');
      }else{
        $('.shipping-in-1-or-2-days .active-filter input:checked').trigger('click');
      }       
    },200);
  });  
});



// Clear All link 

$(document).ready(function() {
  $(document).on('click','.active-filters__clear',function(e){
    e.preventDefault();    
    let new_url = $(this).attr('href');
    console.log(new_url);
     $.ajax({
          type: 'GET', 
          url: new_url,
          dataType: 'html', 
          success: function (filter_html){ 
           $('#ProductGridContainer').html($(filter_html).find('#ProductGridContainer').html());   
            $('.filter-form').html($(filter_html).find('.filter-form').html());   
            window.history.pushState(location.href, "", new_url);
            const api = new Yotpo.API(window.yotpo);
            api.refreshWidgets();
            window.yotpo.initWidgets();
          },
          error: function(){   
            console.log("error");
          }
        });    
  });    
});


//Sort By Filter

 $(document).on('change','.facet-filters__sort',function(e){
   e.preventDefault();   
   $('#sidebarFilter .filter-form').submit();
});
 $(document).on('click','.collection-list',function(e){
   e.preventDefault(); 
   console.log('collections list clicked')
     $(location).attr('href',$(this).find('a').attr('href'));
//    $(this).find('a').trigger('click');
   
});




//Product Grid item products
  $(document).ready(function(){
     $(document).on('click','.first-grid',function(e){
      $('.product-cart-item').addClass('grid-custom');
      $(".grid-change svg").css("display", "none");
      $(".grid-active-button svg").css("display", "block");
    });
         
    $(document).on('click','.grid-change .first-grid',function(e){
      $('.grid-active-button').addClass('grid-svg');
    });
    
    $(document).on('click','.second-grid',function(e){
      $('.product-cart-item').removeClass('grid-custom');
      $(".grid-active-button svg").css("display", "none");
      $(".grid-change svg").css("display", "block");
      $(".grid-active-button svg").css("display", "none");
    });

    $(document).on('click', '.grid-1', function(e) {
      $('.sidebarFilter').addClass('bottom_drawer');
      $('.collections-swip-grid').addClass('bottom_drawer-bg');
      $('body').css({ 'overflow': 'hidden' });
    });

    $(document).on('click', '.wrong-icon-filter', function(e) {
      $('body').css({ 'overflow': 'auto' });
      $('.sidebarFilter').removeClass('bottom_drawer');
      $('.collections-swip-grid').removeClass('bottom_drawer-bg');
      $(".filter-details-container").load(location.href + " .filter-details-container");
    });

    $(document).on('click', '.grid-2', function(e) {
      $('.product-cart-item').removeClass('mobile-grid');
      $('.grid-2').addClass('active-color');
      $('.grid-3').removeClass('color-active');
      $('.collections-grid-custom .product-cart-item .collection-image').height('auto');
    })

    $(document).on('click', '.grid-3', function(e) {
      $('.product-cart-item').addClass('mobile-grid');
      $('.grid-3').addClass('color-active');
      $('.grid-2').removeClass('active-color');
      setTimeout(function() { 
        $('.collections-grid-custom .product-cart-item .collection-image').height($('.collections-grid-custom .product-cart-item:first-child img').height());
      }, 500);
    })
  });



// Quantity BoX JS
$('.qtybox .btnqty').on('click', function(){
  var qty = parseInt($(this).parent('.qtybox').find('.quantity-input').val());
  if($(this).hasClass('qtyplus')) {
    qty++;
  }else {
    if(qty > 1) {
      qty--;
    }
  }
  qty = (isNaN(qty))?1:qty;
  $(this).parent('.qtybox').find('.quantity-input').val(qty);
});


// Product Page Tabing JS
$(document).ready(function(){
  $('ul.tabs li a').click(function(){
    var tab_id = $(this).parent('li').attr('data-tab');
    $(this).parent('li').siblings('li').removeClass('nav-current');
    $(this).closest('ul.tabs').siblings('.tab-content').removeClass('current');
    $(this).parent('li').addClass('nav-current');
    $(this).closest('ul.tabs').siblings("."+tab_id).addClass('current');
  })

})

  $(document).ready(function(){
    if ($(window).width() < 769) {
      setTimeout(function(){
        $('.variable-width').slick({
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          //autoplay: true,
          //autoplaySpeed: 2000,
          adaptiveHeight: true
        });
      },100);
    }
    
   
}); 


 












class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document.getElementById(`Line-item-error-${line}`)
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);


$(document).ready(function(){
  $(document).on('click','.upsellAddtocart',function(w){
  	w.preventDefault();
    $(this).closest('.product-col-app').find('.main-quickview').fadeToggle();
    $('body').addClass('popup-opened');
  });
  $(document).on('click','.popupclose-icon',function(w){
  	w.preventDefault();
    $(this).closest('.product-col-app').find('.main-quickview').fadeToggle();
    $('body').removeClass('popup-opened');
  });
  $(document).on("click",'.qtybox .btnqty',function(){
    var qty = parseInt($(this).parent('.qtybox').find('.popquantity').val());
    if($(this).hasClass('qtyplus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.qtybox').find('.popquantity').val(qty);
  });
});
$(document).ready(function(){

  $(document).on('click','.popupcheckout',function(w){
    let popThis = $(this);
  w.preventDefault();
        
    let recomendedUrl = popThis.closest('.product-col-app').find('.recommended-products').attr('data-url');
    let variantId = parseInt($(this).attr('data-variant-id'));
    let quantity = $(this).closest('.product-col-app').find('.popquantity').val();
    let postData ={
      id:variantId,
      quantity:quantity
    }
    $.ajax({
          type: "POST",
          context: this,
          url: '/cart/add.js',
          data: postData,
          dataType: 'json',
          success: function(product){
            popThis.closest('.product-col-app').find('.success-message').show();
             popThis.closest('.product-col-app').find('.row-list').hide();
             popThis.closest('.product-col-app').find('.row-last').hide();
            console.log(recomendedUrl);
            fetch(recomendedUrl)
            .then(response => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              console.log(recommendations);
               if (recommendations && recommendations.innerHTML.trim().length) {
                  popThis.closest('.product-col-app').find('.recommended-products').html(recommendations.innerHTML)
//               $('.recommended-products').innerHTML = recommendations.innerHTML;
               }
            });
          }
        });
  });
});

 $('.sub-container').each(function(k) {
  var subLink = $(this).parent().find('a').attr('href');
   if (subLink.indexOf('accessories') > -1) {
     
   }
   else {
  var firstHeight = 0;
      var prevShift = 0;
   var thisContainer = $(this).eq(k);
  $(this).find('.sub-links').each(function(i) {
    if (i === 0) {
     firstHeight = $(this).height(); 
    }
    else {
     var height = $(this).height(); 
      if (height <= firstHeight && prevShift === 0 && i != 1) {
        prevShift = 1;
        var prevIndex = i - 1;
                $(this).addClass('appended');
        var detached = $(this).detach();
        $(this).appendTo(thisContainer.find('.sub-links').eq(prevIndex));

      }
      else {
       prevShift = 0; 
      }
      if (height > firstHeight) {
       // create two divs to hold the two lists
       var regularCounter = 1;
       $(this).append('<div class="half first-half"></div>');
       $(this).append('<div class="half second-half"></div>');
       var length = $(this).find('a').length / 2;
       length = Math.ceil(length); 
       
        $(this).find('a').each(function(o) {
         
        if (regularCounter <= length) {
         $(this).appendTo($(this).parent().find('.half.first-half'));
          regularCounter++;
        
        }
        else {
         $(this).appendTo($(this).parent().find('.half.second-half'));
         regularCounter++;
        }
        });
      }
    }
  });
   }
});

var currentURL = window.location.pathname;
console.log('my current URL is ' + currentURL);

if (currentURL === '/') {
  var flickHeight = $('.product-card-container').find('.flickity-viewport').css('height');   
  if (windowW > 768) {
    $('.product-card-container').find('.flickity-viewport').css('height','75vh');
  } else {
    $('.product-card-container').find('.flickity-viewport').css('height','60vh');
  }
}

var headerHeight = $('#Header').outerHeight();
//$('#MainContent').css('padding-top', headerHeight);

$(document).ready(function(){
  $('.image-zoom').each(function() {
    $(this)
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });
  });

  $('.text-link.product-single__thumbnail')
  .on('click', function(evt) {
    evt.preventDefault();

    // Switch Media
    const $currentMedia = $(
      '.image-container' + ':not(.hide)'
    );
    $currentMedia.addClass('hide');

    const $newMedia = $(
      '.image-container.' +
      $(this).data('thumbnail-id')
    );
    $newMedia.removeClass('hide');

    // Switch thumbnail
    const $currentThumbnail = $(
      '.text-link.product-single__thumbnail.active_thumbnail'
    );
    $currentThumbnail.removeClass('active_thumbnail');
    $(this).addClass('active_thumbnail');
  });
  
  const slider = document.querySelector('.product-single__thumbnails');
  let mouseDown = false;
  let startX, scrollLeft;

  let startDragging = function (e) {
    mouseDown = true;
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  };
  let stopDragging = function (event) {
    mouseDown = false;
  };

  slider.addEventListener('mousemove', (e) => {
    e.preventDefault();
    if(!mouseDown) { return; }
    const x = e.pageX - slider.offsetLeft;
    const scroll = x - startX;
    slider.scrollLeft = scrollLeft - scroll;
  });

  // Add the event listeners
  slider.addEventListener('mousedown', startDragging, false);
  slider.addEventListener('mouseup', stopDragging, false);
  slider.addEventListener('mouseleave', stopDragging, false);
});

$(document).on('click','.filter-action__apply',function(e){
  e.preventDefault();
  $('.filter-form').submit();
});

$('#search-icon, #search-icon-mob').click(function(){
  $('.search_slide').addClass('active');
  $('.ps-overlay').addClass('active');
  $('body').addClass('ps-active');
  console.log('search-icon');
  
});
$('.close-ps, .ps-overlay').click(function(){
  $('.search_slide').removeClass('active');
  $('.ps-overlay').removeClass('active');
  $('body').removeClass('ps-active');
});

$(document).ready(function(){
$('.product-single__thumbnails1').flickity({
    asNavFor: '.media-wrapper',
    contain: true,
    imagesLoaded: true,
    pageDots: false
  });
 $('.product-single__thumbnails2').flickity({
    asNavFor: '.media-wrapper',
    contain: true,
    imagesLoaded: true,
    pageDots: false
  });
   
  if(jQuery(document).width() > 767){
    $(".search_slide").appendTo("#Header");
    console.log('shift-desk');    
  }

  
});
//$(window).on('resize', function(){
  if($(document).width() > 767){
    $(".search_slide").appendTo("#Header");
    console.log('resize-mob');
  }
  else{
     $(".search_slide").appendTo(".mobile-search-bar");
      console.log('resize-desk');
  }
//});

jQuery('#wreath-tab').click(function(){
    jQuery('#header-tree').slideUp(0);
    jQuery('#header-accessories').slideUp(0);
    jQuery('#header-wreath').slideDown(400);  
    jQuery(this).addClass('active');
    jQuery('#tree-tab').removeClass('active');
    jQuery('#accessories-tab').removeClass('active');
});

jQuery('#tree-tab').click(function(){
    jQuery('#header-wreath').slideUp(0);
    jQuery('#header-accessories').slideUp(0);
    jQuery('#header-tree').slideDown(400);
    jQuery('#wreath-tab').removeClass('active');
    jQuery('#accessories-tab').removeClass('active');
    jQuery(this).addClass('active');
});

jQuery('#accessories-tab').click(function(){
    jQuery('#header-tree').slideUp(0);
    jQuery('#header-wreath').slideUp(0);
    jQuery('#header-accessories').slideDown(400); 
    jQuery('#tree-tab').removeClass('active');
    jQuery('#wreath-tab').removeClass('active');
  jQuery(this).addClass('active');
});


jQuery('.mobile-only.tab-link').click(function(){
    if(jQuery(this).hasClass('nav-current')){
      jQuery(this).removeClass('nav-current');
      jQuery(this).next('.tab-content').removeClass('current');
    }
    else{
        jQuery(this).siblings('.mobile-only.tab-link').removeClass('nav-current');
        jQuery(this).siblings('.tab-content').removeClass('current');
        var toSelect = jQuery(this).data('tab');
        toSelect = '.tab-content.' + toSelect;
       jQuery(this).siblings(toSelect).addClass('current');
        jQuery(this).addClass('nav-current');
    }
});

//for Nav show/hide on scroll

var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        //hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('body').removeClass('nav-down').addClass('nav-up');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('body').removeClass('nav-up').addClass('nav-down');
        }
    }
    
    lastScrollTop = st;
}




function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}



function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}






/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);







